import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';

const overlay = { position: 'fixed', inset: 0, zIndex: 300, background: 'rgba(6,12,26,0.78)', backdropFilter: 'blur(14px)', display: 'grid', placeItems: 'center', padding: 18 };
const card = { width: '100%', maxWidth: 460, background: 'linear-gradient(180deg, #121C38 0%, #0B1330 100%)', border: '1px solid rgba(91,190,252,0.28)', borderRadius: 22, padding: 26, boxShadow: '0 40px 80px -20px rgba(0,0,0,0.75)' };
const btn = (bg, color) => ({ flex: 1, padding: '13px 16px', borderRadius: 14, border: 'none', cursor: 'pointer', fontFamily: 'Sora', fontWeight: 800, fontSize: 14, background: bg, color, transition: 'transform 0.12s' });

function PointList({ point }) {
  return (
    <ul style={{ margin: '14px 0 0', padding: '0 0 0 18px', color: '#AEB9D6', fontFamily: 'Lexend', fontSize: 12.5, lineHeight: 1.6 }}>
      {point.items.map((it) => <li key={it}>{it}</li>)}
    </ul>
  );
}

export default function DailyProcessPrompt() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [prompt, setPrompt] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get('/daily-process/me');
      setPrompt(data.enabled ? data.prompt : null);
    } catch { setPrompt(null); }
  }, []);

  useEffect(() => {
    if (!user?.id) return undefined;
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, [user?.id, load]);

  if (!prompt) return null;

  const answer = async (a) => {
    await api.post('/daily-process/checkin', { answer: a }).catch(() => {});
    setPrompt(null);
    if (a === 'no') { toast('Ajoute tes tâches de la journée maintenant'); navigate('/tasks?new=1'); }
  };
  const ack = async () => {
    await api.post('/daily-process/ack', { point: prompt.point.id }).catch(() => {});
    setPrompt(null);
  };

  const isCheckin = prompt.kind === 'checkin';
  return (
    <div style={overlay} data-testid="daily-process-prompt">
      <div style={card} className="scale-in">
        <div style={{ fontFamily: 'Sora', fontWeight: 700, fontSize: 11, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#5BBEFC' }}>Point communication</div>
        <h2 data-testid="daily-process-title" style={{ fontFamily: 'Sora', fontWeight: 800, fontSize: 21, color: '#F3F6FF', margin: '8px 0 0', lineHeight: 1.25 }}>
          {isCheckin ? 'As-tu mis tes tâches de la journée ?' : `N'oublie pas le point ${prompt.point.id}`}
        </h2>
        <div style={{ fontFamily: 'Lexend', fontSize: 13, color: '#8A97B8', marginTop: 6 }}>{prompt.point.title}</div>
        {!isCheckin && <PointList point={prompt.point} />}
        <div style={{ display: 'flex', gap: 10, marginTop: 22 }}>
          {isCheckin ? (
            <>
              <button data-testid="daily-checkin-no" onClick={() => answer('no')} style={btn('rgba(255,123,123,0.14)', '#FF8A8A')}>Non</button>
              <button data-testid="daily-checkin-yes" onClick={() => answer('yes')} style={btn('linear-gradient(180deg, #7FD0FF 0%, #3E7BFA 100%)', '#0B1330')}>Oui</button>
            </>
          ) : (
            <button data-testid="daily-point-ack" onClick={ack} style={btn('linear-gradient(180deg, #7FD0FF 0%, #3E7BFA 100%)', '#0B1330')}>OK, je n'oublie pas</button>
          )}
        </div>
      </div>
    </div>
  );
}
